import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { getUri } from 'services/generic';

import styles from './CartNotFound.module.scss';
import { fetcher } from 'services/fetcher';

/**
 * Component display when /get/cart return an error. <br/>
 * Display error message with button to refresh the page.
 */
function CartNotFound(): JSX.Element {
  const { t } = useTranslation();

  function handleCartNotFound() {
    fetcher(`${process.env.REACT_APP_URL_API_CHECKOUT}/cart/reset`).then(() => {
      window.location.href = getUri('/checkout/cart');
    });
  }
  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <p>{t('LABEL_OOPS')}!</p>
          <p>{t('LABEL_AN_ERROR_HAS_OCCURRED')}</p>

          <a onClick={handleCartNotFound} className={styles.redirect}>
            <span>{t('LABEL_UPDATE_MY_BASKET')}</span>
            <ArrowForwardIosIcon className={styles.icon} />
          </a>
        </div>
      </div>
    </>
  );
}

export default CartNotFound;
